import { sortBy, orderBy } from "lodash";
import { addMinutes } from "date-fns";
const getInitialIBData = ({
  IBData,
  selectedShipmentIds,
  planningTerminal,
  isRefresh
}) => {
  const formattedData = IBData.map((data) => {
    const selectedPros = getSelectedProIdsInBatch({
      batchPros: data.shipmentsForDestTerminal,
      selectedShipmentIds,
      isRefresh
  });
    const inPlanBills = getExistingShipmentsInPlan(
      data.shipmentsForDestTerminal
    ).map((pro) => pro.proId);
    const totalBillsSelected = [...selectedPros, ...inPlanBills];
    return {
      ...data,
      shipmentsForDestTerminal: sortBy(data.shipmentsForDestTerminal, [
        (item) => !item.isDefaultSelection,
        (item) => item.isInPlan,
      ]),
      id: getBatchId(data),
      selectedPros,
      isSelected: checkAllBillsSelectedInBatch(
        totalBillsSelected.length,
        data.shipmentsForDestTerminal.length
      ),
      isIntermediate: checkPartialBillsSelectedInBatch(
        totalBillsSelected.length,
        data.shipmentsForDestTerminal.length
      ),
    };
  });
  return sortTrailersData(formattedData, planningTerminal);
};

const getBatchId = (data) => {
  return [
    data.trailerNumber,
    data.trailerScac,
    data.currentTerminal,
    data.destTerminal,
  ].join("");
};

const getSelectedProIdsInBatch = ({ batchPros, selectedShipmentIds = [], isRefresh = false }) => {
  const explicitlySelected = (pro) => selectedShipmentIds.includes(pro.proId);

  const defaultEligible = ({ isDefaultSelection, isInPlan }) => isDefaultSelection && !isInPlan;

  const shouldInclude = isRefresh
    ? explicitlySelected // on refresh, ONLY explicit
    : (pro) => explicitlySelected(pro) || defaultEligible(pro);

  return batchPros.filter(shouldInclude).map(({ proId }) => proId);
};

const getExistingShipmentsInPlan = (shipments) => {
  return shipments.filter((pro) => pro.isInPlan);
};

const checkInPlanShipmentsExistInBatch = (batchShipments) => {
  return batchShipments.some((pro) => pro.isInPlan);
};

const checkAllBillsSelectedInBatch = (
  totalBillsSelected,
  totalBillsInBatch
) => {
  return totalBillsSelected === totalBillsInBatch;
};

const checkPartialBillsSelectedInBatch = (
  totalBillsSelected,
  totalBillsInBatch
) => {
  return totalBillsSelected > 0 && totalBillsSelected < totalBillsInBatch;
};

const sortTrailersData = (trailersData, planningTerminal) => {
  return orderBy(
    trailersData,
    [
      (item) => item.isAtDestinationTerminal ? 1 : -1, //ensure dest bills at top
      (item) => item.currentTerminal === planningTerminal,
      (item) => item.nextTerminal === planningTerminal,
      (item) => item.currentTerminal,
      (item) => item.nextTerminal,
      (item) => item.status,
      (item) => item.trailerIbeta,
    ],
    ["desc", "desc"]
  );
};

const appendTimeInMinutesToDate = (
  selectedPlanDate,
  defaultIBEtaCutOffTimeInMinutes
) => {
  const dateWithTime = addMinutes(
    new Date(selectedPlanDate),
    defaultIBEtaCutOffTimeInMinutes
  );
  return dateWithTime.toISOString();
};
const getDefaultIBEtaCutOff = ({
  ibEtaCutOff,
  planDate,
  defaultIBEtaCutOffTimeInMinutes,
}) => {
  return ibEtaCutOff ? ibEtaCutOff : appendTimeInMinutesToDate(planDate,defaultIBEtaCutOffTimeInMinutes);
}; 

export {
  getInitialIBData,
  getExistingShipmentsInPlan,
  checkInPlanShipmentsExistInBatch,
  checkAllBillsSelectedInBatch,
  checkPartialBillsSelectedInBatch,
  getDefaultIBEtaCutOff
};
